module.exports = __webpack_public_path__ + "img/4-agence-de-comunication-lyon.c8b2227.jpg";